"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAppBaseBindingMarkdown = parseAppBaseBindingMarkdown;
const marked_1 = require("marked");
const app_base_bindings_1 = require("./app-base-bindings");
const parser = new marked_1.Marked({ gfm: true, breaks: true, async: false });
/** Parsing only. The binding engine applies the same DOM/URL policy afterwards. */
function parseAppBaseBindingMarkdown(markdown) {
    if (new TextEncoder().encode(markdown).length >
        app_base_bindings_1.APP_BASE_BINDING_BUDGETS.markdownBytes)
        throw new Error(`Markdown binding exceeds ${app_base_bindings_1.APP_BASE_BINDING_BUDGETS.markdownBytes / 1024} KiB (limit binding.markdownBytes)`);
    return parser.parse(markdown, { async: false });
}
